/***
*
*   NOTIFICATION
*   Banner notification that appears at the top of the screen.
*   Create a notification anytime using context.notification.show()
*   and pass the props below
*
*   PROPS
*   message: string containing the message
*   type - success/error/warning/info
*   autoclose - if false, the notification won't disappear until clicking the X
*
**********/

import React, { useContext } from 'react';
import { ViewContext } from 'components/lib';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { AlertTitle } from '@mui/material';

export function Notification(props) {
  const context = useContext(ViewContext);
  const data = context.notification.data;

  // Fallback to props first (from View) or to context data if missing
  const text = props.text || data.text;
  const type = props.type || data.type || 'info';
  const autoclose = props.autoclose !== undefined ? props.autoclose : data.autoclose;
  const show = props.show !== undefined ? props.show : data.show;

  return (
    <Snackbar
      open={show}
      onClose={context.notification.hide}
      autoHideDuration={autoclose ? 4000 : null}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        elevation={6}
        variant="filled"
        severity={type}  // success | error | warning | info
        onClose={!autoclose ? context.notification.hide : undefined}
        sx={{
          maxWidth: '500px',
        }}
      >
        <AlertTitle style={{ textTransform: 'capitalize' }}>{type}</AlertTitle>
        {text}
      </Alert>
    </Snackbar>
  );
}
